import { useEffect } from 'react';
export const useFormReset = (onReset, inputRef) => {
    useEffect(() => {
        const form = inputRef.current?.closest('form');
        form?.addEventListener('reset', onReset);
        return () => {
            form?.removeEventListener('reset', onReset);
        };
    }, [inputRef, onReset]);
};
